import createAccountDialog from '@/views/components/dialogs/create-account-dialog'
export default {
  components:{
    createAccountDialog
  },
  data(){
    return{
      createAccountDialog:false
    }
  },
  computed: {
  },
  methods:{
    handlerCreateAccount(){
      this.createAccountDialog = true
    }
  }
}
